import React from 'react';

import { IChunkModel } from '@common/models/Chunks/Chunk';

import { StyledChunkImage, StyledChunkImageWrap } from './style';

interface PropsType {
	chunkModel: IChunkModel;
}

function ChunkImage({ chunkModel }: PropsType) {
	return (
		<StyledChunkImageWrap>
			<StyledChunkImage src={chunkModel.image.url} alt="Chunk" />
		</StyledChunkImageWrap>
	);
}

export default ChunkImage;
